// export const API_URL = 'https://jsonplaceholder.typicode.com';
// export const API_URL = 'https://4tp7335g-3370.inc1.devtunnels.ms/W0001/';

// export const API_URL = 'https://hrms.iwebwiser.com/W0001/';
// export const API_URL = 'https://tl2x5pbd-3370.inc1.devtunnels.ms/W0001/';
export const API_URL = 'https://dev.hrms.iwebwiser.com/W0001/';

// export const API_URL = 'http://192.168.68.102/W0001/';

export const API_ENDPOINT = {
  // LOGIN
  login: 'api/v1/auth/login',
  forgetPassword: 'api/v1/auth/forget-password',
  logout: 'api/v1/auth/logout',
  regenerateToken: 'api/v1/auth/regenerate-token',

  // Site
  addSite: 'api/v1/site/add-site',
  getSite: 'api/v1/site/get-site',
  updateSite: 'api/v1/site/edit-site',
  deleteSite: 'api/v1/site/delete-site',

  // company
  addCompany: 'api/v1/hrm/add-company',
  getCompany: 'api/v1/hrm/get-company',

  // leaveSetting
  addLeaveSetting: 'api/v1/hrm/add-leave-setting',
  getLeaveSetting: 'api/v1/hrm/get-leave-setting',
  updateLeaveSetting: 'api/v1/hrm/update-leave-setting',
  deleteLeaveSetting: 'api/v1/hrm/delete-leave-setting',

  // holiday
  addHoliday: 'api/v1/hrm/add-holiday',
  getHoliday: 'api/v1/hrm/get-holiday',
  deleteHoliday: 'api/v1/hrm/delete-holiday',

  // shift
  addShift: 'api/v1/hrm/add-shift',
  getShift: 'api/v1/hrm/get-shift',
  updateShift: 'api/v1/hrm/update-shift',
  deleteShift: 'api/v1/hrm/delete-shift',

  // Document
  addDocuments: 'api/v1/hrm/add-documents',
  deleteDocument: 'api/v1/site/delete-document',

  // salary head
  createSalaryHead: 'api/v1/account/create-salary-head',
  getSalaryHead: 'api/v1/account/get-salary-head?',
  updateSalaryHead: 'api/v1/account/update-salary-head',

  // department
  addDepartment: 'api/v1/hrm/add-department',
  getDepartment: 'api/v1/hrm/get-department',
  updateDepartment: 'api/v1/hrm/update-department',
  deleteDepartment: 'api/v1/hrm/delete-department',

  // designation
  addDesignation: 'api/v1/hrm/add-designation',
  getDesigantion: 'api/v1/hrm/get-designation',
  updateDesignation: 'api/v1/hrm/update-designation',

  // Attendance
  getAttendance: 'api/v1/user/get-attendance',
  getAttendanceDetail: 'api/v1/user/get-attendance-detail',
  markAttendance: 'api/v1/user/mark-attendance',
  lockAttendance: 'api/v1/hrm/lock-attendance',
  deleteAr: 'api/v1/user/delete-attendance',
  getAttendanceSummary: 'api/v1/user/get-attendance-summary',
  getAttendanceLog: 'api/v1/user/get-attendance-log',
  sendReminder: 'api/v1/auth/send-reminder',

  // Profile
  getProfile: 'api/v1/user/get-profile',

  // ar Request
  createAr: 'api/v1/user/create-arrequest',
  getAr: 'api/v1/user/get-arrequest',
  editAr: 'api/v1/user/edit-arrequest',
  getArDetail: 'api/v1/user/get-arrequest-detail',

  // wfh request
  createWfh: 'api/v1/user/create-odrequest',
  getWfh: 'api/v1/user/get-odrequest',
  editWfh: 'api/v1/user/edit-odrequest',
  getWfhRequestDetail: 'api/v1/user/get-odrequest-detail',
  deleteWfh: 'api/v1/user/delete-odrequest',

  // Employee
  getEmployee: 'api/v1/hrm/get-employee',
  addEmployee: 'api/v1/hrm/add-employee',

  // Leave
  addLeave: 'api/v1/user/add-leave',
  getLeave: 'api/v1/user/get-leave',
  updateLeave: 'api/v1/user/update-leave',
  deleteLeave: 'api/v1/user/delete-leave',
  getLeaveDetail: 'api/v1/user/get-leave-detail',
  addUnpaidLeave: 'api/v1/user/add-unpaid-leave',
  updateUnpaidLeave: 'api/v1/user/update-unpaid-leave',
  deleteUnpaidLeave: 'api/v1/user/delete-unpaid-leave',

  // count
  getLeaveCount: 'api/v1/user/get-counts',

  // verification
  verification: 'api/v1/user/verification',

  // previous work
  addPreviousWork: 'api/v1/hrm/add-previousWork',

  // User salary
  createUserSalary: 'api/v1/account/create-user-salary',
  getUserSalary: 'api/v1/account/get-user-salary',
  updateUserSalary: 'api/v1/account/update-user-salary',

  // monthly user Salary
  createMonthlyUserSalary: 'api/v1/account/create-monthly-user-salary',
  getMonthlyUserSalary: 'api/v1/account/get-monthly-user-salary',
  deleteMonthlyUserSalary: 'api/v1/account/delete-monthly-user-salary',

  // site Salary head
  createSiteSalaryHead: 'api/v1/account/create-site-salary-head',
  getSiteSalaryHead: 'api/v1/account/get-site-salary-head',
  updatesSitesSalaryHead: 'api/v1/account/update-site-salary-head',
  deleteSitesSalaryHead: 'api/v1/account/delete-site-salary-head',
  getSiteSalaryHeadDetail: 'api/v1/account/get-site-salary-head-detail',

  // birthday or work
  getBirthdayAnniversary: 'api/v1/user/get-birthday-anniversary',

  // export data
  getExportData: 'api/v1/user/get-export-data?',

  // getLogs
  getLogs: 'api/v1/user/get-logs',

  // update user status
  userStatusUpdate: 'api/v1/user/update-status',

  // offer Letter
  getOfferLetter: 'api/v1/hrm/generate-offer-letter',

  // payslip
  genereatePaySlip: 'api/v1/account/generate-pay-slip?',
  getOfficeForTeamPayslip: 'api/v1/account/get-sites-for-team-payslip',
  manualSalaryAdjustment: 'api/v1/account/manual-salary-adjustment/',
  getSalaryAdjustment: 'api/v1/account/get-salary-adjustment/',

  // Site wise user Salary
  updateSiteWiseUserSalary:
    'api/v1/account/update-site-wise-user-salary?siteId=',
  getSiteWiseUserSalary: 'api/v1/account/get-site-wise-user-salary',

  // Notification
  createNotification: 'api/v1/user/create-notification',
  getNotification: 'api/v1/user/get-notification',

  // Notification Count
  getNotificationCount: 'api/v1/user/get-notification-count',
  //biometric device
  addDevice: 'api/v1/hrm/add-device',
  getDevice: 'api/v1/hrm/get-device',
  //policy
  addPolicy: 'api/v1/hrm/add-policy',
  updatePolicy: 'api/v1/hrm/update-policy?id=',
  getPolicy: 'api/v1/hrm/get-policy',
  deletePolicy: 'api/v1/hrm/delete-policy?policyId=',
  //assets category
  addAssetsCategory: 'api/v1/site/add-asset-category',
  getAssetsCategory: 'api/v1/site/get-asset-category',
  deleteAssetsCategory: 'api/v1/site/delete-asset-category?assetCategoryId=',
  //assets
  addAssets: 'api/v1/site/add-asset',
  assetList: 'api/v1/site/get-asset-list',
  updateAssets: 'api/v1/site/update-asset',
  getAsset: 'api/v1/site/get-asset',
  deleteAssets: 'api/v1/site/delete-asset?assetId=',
  historyAssets: 'api/v1/site/get-asset-history',
  downloadAssignedAssetExcel: 'api/v1/site/download-assigned-asset-excel',
  //asset request
  addAssetRequest: 'api/v1/site/add-asset-request',
  assetRequestList: 'api/v1/site/get-assigne-asset',
  updateAssetRequest: 'api/v1/site/update-asset-request',
  deleteAssetRequest: 'api/v1/site/delete-asset-request',

  // Forms
  getForms: 'api/v1/hrm/list-office-form',
  getFormById: 'api/v1/hrm/get-office-form',
  createForm: 'api/v1/hrm/create-office-form',
  updateForm: 'api/v1/hrm/update-form',
  deleteForm: 'api/v1/hrm/delete-office-form',
  formSubmission: 'api/v1/hrm/form-submission',
  getTeamsFormSubmission: 'api/v1/hrm/get-form-submission',
  getSubmissionForms: 'api/v1/hrm/get-teams-submission',
  submitManagerReview: 'api/v1/hrm/submit-manager-review',

  // off boarding
  // deleteOffboarding : 'api/v1/account/off-board-user',
  getOffboardingList: 'api/v1/account/off-board-user-list',
  offboardUser: 'api/v1/account/off-board-user',
  offbordingDetails: 'api/v1/account/get-off-board-user',
};
